import React from 'react';

const SettingsMenu = () => {
  return (
    <div>SettingsMenu</div>
  );
};

export default SettingsMenu;
